<template>
  <div>
    <div id="menu">
      <b-container>
        <b-nav>
          <b-nav-item to="/test/font" active-class="active"
            >Шрифт</b-nav-item
          >
          <b-nav-item to="/test/components" active-class="active"
            >Компоненты</b-nav-item
          >
          <b-nav-item to="/test/pages" active-class="active"
            >Страницы</b-nav-item
          >
        </b-nav>
      </b-container>
    </div>

    <b-container id="content">
      <!-- Компонент -->
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "ThemePreviewAndTesting",
};
</script>

<style scoped>
.show-margin {
  background-color: #f9ffc9;
  display: flow-root;
}
.show-margin > * {
  background-color: white;
}
</style>